<template>
  <div>
    <AppNavbar />
    <div class="container mt-5">
      <AppHeader title="Notas de crédito">
        <template #buttons>
          <button type="button" class="btn btn-outline-secondary" :disabled="cargando" @click="cargar(1)">
            <i class="bi bi-arrow-repeat me-1"></i>Recargar
          </button>
        </template>
      </AppHeader>

      <div class="card p-3 mt-4">
        <!-- Historial y entrega (SPEC_ANULACION_FACTURAS_Y_NOTAS_CREDITO_v0.2.md
             RN-AN24 a RN-AN27). No emite notas de crédito: eso lo hace la
             anulación de una factura (o la fase 2). -->
        <div class="row g-2 align-items-end mb-3">
          <div class="col-6 col-md-2">
            <label class="form-label small mb-1" for="ncDesde">Desde</label>
            <input id="ncDesde" v-model="filtros.desde" type="date" class="form-control form-control-sm" />
          </div>
          <div class="col-6 col-md-2">
            <label class="form-label small mb-1" for="ncHasta">Hasta</label>
            <input id="ncHasta" v-model="filtros.hasta" type="date" class="form-control form-control-sm" />
          </div>
          <div class="col-6 col-md-2">
            <label class="form-label small mb-1" for="ncOrigen">Origen</label>
            <select id="ncOrigen" v-model="filtros.origen" class="form-select form-select-sm">
              <option value="">Todos</option>
              <option value="ANULACION">Anulación</option>
              <option value="DEVOLUCION">Devolución</option>
            </select>
          </div>
          <div class="col-6 col-md-4">
            <label class="form-label small mb-1" for="ncTexto">Cliente o número</label>
            <input id="ncTexto" v-model="filtros.q" type="search" class="form-control form-control-sm" @keyup.enter="cargar(1)" />
          </div>
          <div class="col-12 col-md-2">
            <button type="button" class="btn btn-primary btn-sm w-100" @click="cargar(1)">Buscar</button>
          </div>
        </div>

        <div class="table-responsive">
          <table class="table table-striped align-middle mb-0">
            <thead>
              <tr>
                <th>N° nota de crédito</th>
                <th>Origen</th>
                <th>Cliente</th>
                <th>Factura que acredita</th>
                <th class="text-end">Monto</th>
                <th>Estado</th>
                <th>Fecha</th>
                <th>Acciones</th>
              </tr>
            </thead>
            <tbody>
              <tr v-if="cargando"><td colspan="8" class="text-center py-4">Cargando…</td></tr>
              <tr v-else-if="error"><td colspan="8" class="text-center py-4 text-danger">{{ error }}</td></tr>
              <tr v-else-if="!items.length"><td colspan="8" class="text-center py-4">No hay notas de crédito para mostrar.</td></tr>
              <tr v-else v-for="nc in items" :key="nc.id_devolucion">
                <td>{{ nc.numero || '—' }}</td>
                <td>{{ nc.origen === 'ANULACION' ? 'Anulación' : 'Devolución' }}</td>
                <td>{{ nc.cliente || '—' }}</td>
                <td>{{ nc.factura?.numero || '—' }}</td>
                <td class="text-end">{{ formatearMonto(nc.monto) }}</td>
                <td>
                  <span :class="['badge', badgeEstado(nc)]">{{ textoEstado(nc) }}</span>
                  <div v-if="nc.requiere_atencion" class="small text-danger mt-1">{{ nc.motivo_atencion }}</div>
                </td>
                <td>{{ formatearFecha(nc.fecha) }}</td>
                <td>
                  <button type="button" class="btn btn-outline-success btn-sm" @click="abrirEntrega(nc)">
                    <i class="bi bi-send me-1"></i>Entregar
                  </button>
                </td>
              </tr>
            </tbody>
          </table>
        </div>
      </div>

      <AppPagination class="mt-3" :currentPage="pagina" :totalPages="totalPaginas" @page-changed="cargar" />
    </div>

    <div v-if="entrega.abierto" class="modal fade show d-block" tabindex="-1" role="dialog" aria-modal="true">
      <div class="modal-dialog modal-lg">
        <div class="modal-content">
          <div class="modal-header">
            <h5 class="modal-title">Entregar nota de crédito</h5>
            <button type="button" class="btn-close" aria-label="Cerrar" @click="entrega.abierto = false"></button>
          </div>
          <div class="modal-body">
            <div v-if="entrega.cargando" class="text-center py-3">Cargando…</div>
            <div v-else-if="entrega.error" class="alert alert-danger mb-0">{{ entrega.error }}</div>
            <ComprobanteEntrega v-else-if="entrega.documento" :documento="entrega.documento" />
          </div>
          <div class="modal-footer">
            <button type="button" class="btn btn-outline-secondary" @click="entrega.abierto = false">Cerrar</button>
          </div>
        </div>
      </div>
    </div>
    <div v-if="entrega.abierto" class="modal-backdrop fade show"></div>
  </div>
</template>

<script>
import AppNavbar from '@/components/AppNavbar.vue';
import AppHeader from '@/components/AppHeader.vue';
import AppPagination from '@/components/AppPagination.vue';
import ComprobanteEntrega from '@/components/ComprobanteEntrega.vue';
import { listarNotasCredito, comprobanteNotaCredito, mensajeDeError } from '@/services/anulacionService';

const POR_PAGINA = 20;

export default {
  name: 'NotasCreditoView',
  components: { AppNavbar, AppHeader, AppPagination, ComprobanteEntrega },
  data() {
    return {
      items: [],
      total: 0,
      pagina: 1,
      cargando: false,
      error: '',
      filtros: { desde: '', hasta: '', origen: '', q: '' },
      entrega: { abierto: false, cargando: false, error: '', documento: null }
    };
  },
  computed: {
    totalPaginas() {
      return Math.max(1, Math.ceil(this.total / POR_PAGINA));
    }
  },
  mounted() {
    this.cargar(1);
  },
  methods: {
    async cargar(pagina = this.pagina) {
      this.cargando = true;
      this.error = '';
      try {
        const filtros = Object.fromEntries(Object.entries(this.filtros).filter(([, v]) => v));
        const data = await listarNotasCredito({ ...filtros, limit: POR_PAGINA, offset: (pagina - 1) * POR_PAGINA });
        this.items = data?.items || [];
        this.total = Number(data?.total || 0);
        this.pagina = pagina;
      } catch (error) {
        this.items = [];
        this.error = mensajeDeError(error, 'No se pudieron cargar las notas de crédito.');
      } finally {
        this.cargando = false;
      }
    },
    async abrirEntrega(nc) {
      this.entrega = { abierto: true, cargando: true, error: '', documento: null };
      try {
        this.entrega.documento = await comprobanteNotaCredito(nc.id_devolucion);
      } catch (error) {
        this.entrega.error = mensajeDeError(error, 'No se pudo cargar la nota de crédito.');
      } finally {
        this.entrega.cargando = false;
      }
    },
    textoEstado(nc) {
      const e = String(nc.estado_documento || '').toUpperCase();
      if (nc.requiere_atencion || e === 'REJECTED') return 'Rechazada';
      if (e === 'APPROVED' || e === 'APPROVED_WITH_OBS') return 'Aprobada';
      if (e.startsWith('QUEUED_') || e.startsWith('SENT_')) return 'En camino a la SET';
      return e || '—';
    },
    badgeEstado(nc) {
      const t = this.textoEstado(nc);
      if (t === 'Aprobada') return 'bg-success';
      if (t === 'Rechazada') return 'bg-danger';
      return 'bg-warning text-dark';
    },
    formatearMonto(valor) {
      return Number(Math.round(Number(valor) || 0)).toLocaleString('es-PY');
    },
    formatearFecha(valor) {
      if (!valor) return '—';
      const f = new Date(valor);
      return Number.isNaN(f.getTime()) ? '—' : `${f.toLocaleDateString('es-PY')} ${f.toLocaleTimeString('es-PY', { hour: '2-digit', minute: '2-digit' })}`;
    }
  }
};
</script>

<style scoped>
.card {
  box-shadow: 0 4px 10px rgba(0, 0, 0, 0.08);
}
</style>
